// Generated by scripts/sync-changelog.cjs from CHANGELOG.md. Do not edit by hand.

export interface ReleaseNoteVersion {
  version: string;
  date: string;
  new: string[];
  changed: string[];
  fix: string[];
}

export const RELEASE_NOTES: ReleaseNoteVersion[] = [
  {
    version: '2.3.0',
    date: '2026-09-02',
    new: [
      'A banner appears when a newer version of the app is live, and Update refreshes you onto it',
    ],
    changed: [],
    fix: [],
  },
  {
    version: '2.2.0',
    date: '2026-09-02',
    new: [],
    changed: [],
    fix: [
      'Signing in with an existing username no longer sends you to the "choose a username" screen or leaves you stuck there until you refresh',
    ],
  },
  {
    version: '2.1.0',
    date: '2026-08-29',
    new: [
      'Release Notes in your account settings, so you can catch up on what changed in each version',
      'A "What\'s new" button appears in the top corner when there is an update you have not read yet',
    ],
    changed: [
      'Every settings section now has its own web address, so you can bookmark or share a link straight to it',
    ],
    fix: [
      'Older links to your settings still open the section you expected',
    ],
  },
  {
    version: '2.0.0',
    date: '2026-08-29',
    new: [
      'A proper home page that explains what Karting Stats does before you sign up',
      'Cookie, privacy, and terms pages',
      'Pick a username, so other drivers can find you without you sharing your email address',
      'Follow other drivers, accept your own followers, and compare times with the people you actually race',
      'Choose whether your profile is public or private, and change your mind whenever you like',
      'Account settings for your name, profile picture, email address, and password',
      'Profile pictures now appear next to your name on leaderboards, comparisons, and track pages',
    ],
    changed: [
      'Visitors who are not signed in land on the home page instead of a sign-in screen',
      'Leaderboards, session history, and comparisons only show drivers you are allowed to see',
      'Your email address is no longer shown to other drivers anywhere in the app',
      'Profile pictures are resized for you when you upload them, so they load quickly',
    ],
    fix: [
      'Private drivers no longer turn up in track stats or comparison results',
      'Sessions brought over from older timing systems no longer show email addresses',
    ],
  },
  {
    version: '1.3.0',
    date: '2026-08-06',
    new: [
      'Track stats pages with lap history, rankings, and a breakdown of each session',
      'The app version is now shown in the menu',
    ],
    changed: [
      'Easier navigation and tidier layouts on phones',
    ],
    fix: [
      'Track stats pages open reliably, and rankings appear in the right order',
    ],
  },
  {
    version: '1.2.0',
    date: '2026-07-09',
    new: [
      'Bring in a batch of past lap times from a timing export instead of typing them one by one',
    ],
    changed: [
      'Cleaner track and session pages',
    ],
    fix: [
      'Imported sessions and tracks now save correctly',
    ],
  },
  {
    version: '1.1.0',
    date: '2026-06-26',
    new: [
      'Richer track pages, with driver cards and leaderboards',
    ],
    changed: [
      'Personal bests and how you stack up against the field are easier to read',
    ],
    fix: [
      'Track pages no longer lose their layout on smaller screens',
    ],
  },
  {
    version: '1.0.0',
    date: '2026-06-25',
    new: [
      'Create an account and sign in',
      'Log your lap times session by session, and edit them later',
      'A personal overview, plus an overview across every driver',
      'Head-to-head comparisons you can save and come back to',
      'Track list, track pages, and leaderboards',
      'Driver list',
      'Keep track of your karting vouchers',
    ],
    changed: [],
    fix: [],
  },
];

export const LATEST_RELEASE_VERSION = RELEASE_NOTES[0]?.version ?? '0.0.0';
